import React from "react";
import { useNavigate } from "react-router-dom";
import Rectangle1 from "../assets/Rectangle1.svg";
import Rectangle2 from "../assets/Rectangle2.svg";
import Rectangle3 from "../assets/Rectangle3.svg";
import Rectangle4 from "../assets/Rectangle4.svg";

const supermarkets = [
  { img: Rectangle1, platform: "sainsbury" },
  { img: Rectangle2, platform: "tesco" },
  { img: Rectangle3, platform: "asda" },
  { img: Rectangle4, platform: "morrison" },
];

function SupermarketTabs() {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-2 gap-3 rounded-2xl border border-slate-200 bg-white p-4 sm:grid-cols-4 max-w-3xl">
      {supermarkets.map((s) => (
        <img
          src={s.img}
          key={s.platform}
          alt={s.platform}
          role="button"
          tabIndex={0}
          onClick={() => navigate(`/platform/${s.platform}`)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              navigate(`/platform/${s.platform}`);
            }
          }}
          className="rounded-xl bg-slate-50  text-xs font-semibold text-slate-700 hover:border-indigo-500 hover:text-indigo-600 cursor-pointer"
        />
      ))}
    </div>
  );
}

export default SupermarketTabs;